import { useState, useEffect } from "react";
import { Users, MapPin, Globe } from "lucide-react";

const sections = [
  { id: "about", label: "About" },
  { id: "people", label: "People", icon: Users, colour: "#bb321a" },
  { id: "place", label: "Place", icon: MapPin, colour: "#10B981" },
  { id: "planet", label: "Planet", icon: Globe, colour: "#bb321a" },
];

export default function ScrollProgress() {
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => {
      for (const s of [...sections].reverse()) {
        const el = document.getElementById(s.id);
        if (el && el.getBoundingClientRect().top <= 200) {
          setActive(s.id);
          return;
        }
      }
      setActive("");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!active) return null;

  return (
    <div
      data-testid="scroll-progress"
      className="fixed right-6 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col items-center gap-3"
    >
      {sections.filter(s => s.icon).map((s) => {
        const Icon = s.icon;
        const isActive = active === s.id;
        return (
          <button
            key={s.id}
            onClick={() => document.getElementById(s.id)?.scrollIntoView({ behavior: "smooth" })}
            className={`group relative flex items-center justify-center transition-all duration-300 ${
              isActive ? "w-10 h-10" : "w-6 h-6"
            }`}
            title={s.label}
          >
            <div
              className={`rounded-full flex items-center justify-center transition-all duration-300 ${
                isActive
                  ? "w-10 h-10 bg-white/15 backdrop-blur-sm border border-white/20"
                  : "w-6 h-6 bg-white/5 hover:bg-white/10"
              }`}
            >
              <Icon
                className={`transition-all duration-300 ${isActive ? "w-5 h-5" : "w-3 h-3"}`}
                style={{ color: isActive ? s.colour : "rgba(255,255,255,0.3)" }}
                strokeWidth={1.5}
              />
            </div>
            {/* Label on hover */}
            <span className="absolute right-full mr-3 text-xs font-semibold text-white/70 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              {s.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
